// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"219ea1ad","239":"2a1429da","455":"ce714665"}[chunkId] + ".chunk.js";
};